export default __webpack_public_path__ + "static/media/matching_green.00386cf2.svg";